import { render, staticRenderFns } from "./EventCalendarDay.vue?vue&type=template&id=148e8ef6&"
import script from "./EventCalendarDay.vue?vue&type=script&lang=js&"
export * from "./EventCalendarDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports